import {
  GET_CREDITOPTION,
  GET_CREDITOPTION_SUCCESS,
  GET_CREDITOPTION_FAIL,
  DELETE_CREDITOPTION,
  DELETE_CREDITOPTION_SUCCESS,
  DELETE_CREDITOPTION_FAIL,
  UPDATE_CREDITOPTION,
  UPDATE_CREDITOPTION_SUCCESS,
  UPDATE_CREDITOPTION_FAIL,
  ADD_NEW_CREDITOPTION,
  ADD_CREDITOPTION_SUCCESS,
  ADD_CREDITOPTION_FAIL,
  CREDITOPTION_LOADING,
  CREDITOPTION_RESET,
} from "./actionType";

export const resetCreditOptionState = (actionType) => ({
  type: CREDITOPTION_RESET,
  payload: { actionType },
});

export const getCreditOptionSuccess = (actionType, data) => ({
  type: GET_CREDITOPTION_SUCCESS,
  payload: { actionType, data },
});

export const getCreditOptionFail = (actionType, error) => ({
  type: GET_CREDITOPTION_FAIL,
  payload: { actionType, error },
});

export const getCreditOption = data => ({
  type: GET_CREDITOPTION,
  payload: data,
});

export const getCreditOptionLoading = () => ({
  type: CREDITOPTION_LOADING
});

export const deleteCreditOption = data => ({
  type: DELETE_CREDITOPTION,
  payload: data,
});

export const deleteCreditOptionSuccess = data => ({
  type: DELETE_CREDITOPTION_SUCCESS,
  payload: data,
});

export const deleteCreditOptionFail = error => ({
  type: DELETE_CREDITOPTION_FAIL,
  payload: error,
});

export const updateCreditOption = data => ({
  type: UPDATE_CREDITOPTION,
  payload: data,
});

export const updateCreditOptionFail = error => ({
  type: UPDATE_CREDITOPTION_FAIL,
  payload: error,
});

export const updateCreditOptionSuccess = data => ({
  type: UPDATE_CREDITOPTION_SUCCESS,
  payload: data,
});

export const addNewCreditOption = data => ({
  type: ADD_NEW_CREDITOPTION,
  payload: data,
});

export const addCreditOptionSuccess = data => ({
  type: ADD_CREDITOPTION_SUCCESS,
  payload: data,
});

export const addCreditOptionFail = error => ({
  type: ADD_CREDITOPTION_FAIL,
  payload: error,
});